/**
 * @param {object} attributes an object of attributes and their values to be used for the inserted script tag.
 * @returns {Promise<Event>}
 */
export function injectScript(attributes) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement('script')
    scriptElement.type = 'text/javascript'
    scriptElement.addEventListener('load', event => resolve(event))
    scriptElement.addEventListener('error', _event => reject(new Error(`Failed to load script: ${attributes.src}`)))

    if (attributes) {
      for (const [attribute, value] of Object.entries(attributes)) {
        scriptElement.setAttribute(attribute, value)
      }
    }

    const firstScriptElement = document.getElementsByTagName('script')[0]
    if (firstScriptElement instanceof Node) {
      firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement)
    } else {
      document.body.appendChild(scriptElement)
    }
  })
}
